// extracted by mini-css-extract-plugin
export default {"main":"Repo_main__wYc1D","listSection":"Repo_listSection__zokim","downloadList":"Repo_downloadList__XGFEs","item":"Repo_item__AetYt","buttonLight":"Repo_buttonLight__LtXS6"};